










































































import { PublishmentOrder } from "@/interfaces/publishmentorder";
import Vue, { PropType } from "vue";
export default Vue.extend({
  props: {
    publishmentOrder: Object as PropType<PublishmentOrder>
  },
  data() {
    return {
      active: false,
      req: {
        paidAt: null,
        paymentMethod: "",
        paymentNote: "",
        paymentType: "",
        isPaid: true
      },
      errors: {} as Record<string, string>
    };
  },
  mounted() {
    if (this.$props.publishmentOrder.paymentType) {
      this.req.paymentType = this.$props.publishmentOrder.paymentType;
    }
  },
  methods: {
    click() {
      this.active = true;
    },
    async exec(cb: () => void) {
      if (!this.publishmentOrder) {
        return;
      }

      let hasErrors = false;

      if (!this.req.paidAt) {
        this.$set(this.errors, "paidAt", "※必須です");
        hasErrors = true;
      }

      if (["direct", "other"].indexOf(this.req.paymentType) < 0) {
        this.$set(this.errors, "paymentType", "※正しい選択肢ではありません");
      }
      if (this.req.paymentType == "other" && !this.req.paymentMethod) {
        this.$set(this.errors, "paymentMethod", "※必須です");
        hasErrors = true;
      }

      if (hasErrors) {
        cb();
        return;
      }

      const req = this.req;

      req.paymentMethod =
        req.paymentType == "other" ? req.paymentMethod : "bank_transfer";

      // console.log(req);
      await this.$store.dispatch("patch", [
        this.publishmentOrder["@id"] + "/payment",
        req
      ]);
      this.$emit("success");
      this.active = false;
      cb();
    }
  },
  computed: {
    buttonDisabled(): boolean {
      if (!this.publishmentOrder) {
        return true;
      }
      if (this.publishmentOrder.paymentStatus === "paid") {
        return true;
      }
      if (this.publishmentOrder.paymentStatus === "waiting") {
        if (this.publishmentOrder.paymentMethod !== "bank_transfer") {
          return true;
        }
      }
      return false;
    }
  }
});
